module.exports = __webpack_public_path__ + "media/images/content/BTN_CHECK-02-9011b946a5bb9b2e64e4aed5785d1ed1.svg";